import React from "react";
import { Button, Tooltip, Text } from "@fluentui/react-northstar";
import Constants from "../../../constants/text-constants";
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import AvailableStatus from "../Status/AvailableStatus";
import UnavailableStatus from "../Status/UnavailableStatus";

const TeamButton = observer((props) => {
  const { loggedIn, text, id, onClickHandler } = props;

  const tooltipText = loggedIn
    ? Constants.CLICK_TO_BECOME_UNAVAILABLE
    : Constants.CLICK_TO_BECOME_AVAILABLE;

  return (
    <Tooltip
      trigger={
        <Button
          data-testid={"teamButton" + id}
          className="teamButton"
          content={<Text weight="semibold">{text}</Text>}
          secondary
          icon={loggedIn ? <AvailableStatus /> : <UnavailableStatus />}
          onClick={() => onClickHandler(id, loggedIn)}
        />
      }
      content={tooltipText}
    />
  );
});

TeamButton.propTypes = {
  loggedIn: PropTypes.bool,
  text: PropTypes.string,
  id: PropTypes.number,
  onClickHandler: PropTypes.func,
};

TeamButton.defaultProps = {
  loggedIn: false,
  text: "",
};

export default TeamButton;
